import {AiOutlineSound} from "react-icons/ai";
import {PiPauseBold} from "react-icons/pi";
import {GrCaretPrevious} from "react-icons/gr";
import {GrCaretNext} from "react-icons/gr";
import {ButtonPulse, HoldButton, ProgressBarWithPause,CheckBox, Odometer, Modal,LineSpinner,Draggable,DraggableWithOrder} from "../../shared";

export {
    AiOutlineSound,
    PiPauseBold,
    GrCaretNext,
    GrCaretPrevious,
    ButtonPulse,
    HoldButton,
    Modal,
    Odometer,
    LineSpinner,
    ProgressBarWithPause,
    CheckBox,
    Draggable,
    DraggableWithOrder
}

export const localStorageKeys = {
    appContext: "playerScenarioProgress",
    highScore: "trustyHighScore"
}